import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=75a80fce&scoped=true&"
import script from "./IconSet.vue?vue&type=script&lang=js&"
export * from "./IconSet.vue?vue&type=script&lang=js&"
import style0 from "./IconSet.vue?vue&type=style&index=0&id=75a80fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a80fce",
  null
  
)

export default component.exports